<!-- 管理端-月报详情-审核 -->
<template>
  <div class="project_index_main month_report_main">
    <div class="project_breadcrumb_box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/adminhome/report' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item>月报列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="project_header_box" style="margin-bottom:15px">
      <el-button type="text" icon="el-icon-arrow-left" @click="$router.back()">返回项目列表</el-button>
    </div>
    <div class="project_detail_box">
      <div class="project_name_box">{{ projectInfo.project_name || '加载中...' }}</div>
      <div class="project_info_box">
        <p>承接单位：{{ projectInfo.organ_name || '' }}</p>
      </div>
    </div>

    <div class="month_report_content_box">
      <div class="month_report_search_box">
        <h2>月报记录</h2>
      </div>
      <div class="month_report_table_box">
        <el-table :data="tableData">
          <el-table-column label="月份">
            <template slot-scope="scope">{{ scope.row.month_report || '' }}</template>
          </el-table-column>
          <el-table-column label="项目整体自评进度">
            <template slot-scope="scope">
              <el-progress :percentage="Number(scope.row.progress) || 0"></el-progress>
            </template>
          </el-table-column>
          <el-table-column label="提交时间">
            <template slot-scope="scope">{{ scope.row.submit_time_str || '' }}</template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row)" size="small">{{ scope.row.status_text }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button type="info" size="small" @click="openView(scope.row)">查看</el-button>
              <template v-if="scope.row.is_save == 0 && scope.row.approve_status == 0">
                <el-button type="success" size="small" @click="handleApprove(scope.row)">通过</el-button>
                <el-button type="danger" size="small" @click="handleReject(scope.row)">驳回</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="tableData.length === 0" style="text-align:center;padding:40px;color:#999">暂无月报记录</div>
      </div>
    </div>

    <!-- 查看弹窗 -->
    <el-dialog :title="'月报详情 — ' + (viewForm.month_report || '')" :visible.sync="viewShow" width="900px">
      <el-form :model="viewForm" label-position="top" disabled>
        <el-form-item label="自评进度">
          <el-input v-model="viewForm.progress" style="width:200px"><template slot="append">%</template></el-input>
        </el-form-item>
        <el-form-item label="本月重点工作完成情况">
          <el-input type="textarea" :rows="4" v-model="viewForm.performance" resize="none"></el-input>
        </el-form-item>
        <el-form-item label="遇到的问题与困难">
          <el-input type="textarea" :rows="4" v-model="viewForm.question" resize="none"></el-input>
        </el-form-item>
        <el-form-item label="工作总结与亮点">
          <el-input type="textarea" :rows="4" v-model="viewForm.lightspot" resize="none"></el-input>
        </el-form-item>
        <el-form-item label="下月工作计划">
          <el-input type="textarea" :rows="4" v-model="viewForm.plan" resize="none"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="viewShow = false">关 闭</el-button>
        <template v-if="viewForm.is_save == 0 && viewForm.approve_status == 0">
          <el-button type="success" @click="handleApprove(viewForm); viewShow = false">审核通过</el-button>
          <el-button type="danger" @click="handleReject(viewForm); viewShow = false">驳回</el-button>
        </template>
      </div>
    </el-dialog>

    <!-- 驳回弹窗 -->
    <el-dialog title="驳回原因" :visible.sync="rejectShow" width="450px">
      <el-input type="textarea" :rows="4" v-model="refundReason" placeholder="请输入驳回原因（必填）"></el-input>
      <div slot="footer">
        <el-button @click="rejectShow = false">取 消</el-button>
        <el-button type="danger" @click="confirmReject">确认驳回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { adminGetProjectDetail, adminGetReportList, adminApproveReport } from "@/api/adminModule";

export default {
  data() {
    return {
      projectId: 0, projectInfo: {},
      tableData: [],
      viewShow: false, viewForm: {},
      rejectShow: false, refundReason: '', rejectRow: null,
    };
  },
  created() {
    this.$emit("setActive", { active: 10 });
    this.projectId = this.$route.query.projectId || 0;
    if (this.projectId) { this.getProjectDetail(); this.getReportData(); }
  },
  methods: {
    async getProjectDetail() {
      const res = await adminGetProjectDetail(this.projectId);
      if (res && res.code === 200) this.projectInfo = res.data || {};
    },
    async getReportData() {
      const res = await adminGetReportList({ project_id: this.projectId, pageIndex: 1, pageSize: 50 });
      if (res && res.code === 200) {
        this.tableData = res.data.data || [];
      }
    },
    openView(row) { this.viewForm = { ...row }; this.viewShow = true; },
    async handleApprove(row) {
      const res = await adminApproveReport({ id: row.id, approve_status: 2 });
      if (res && res.code === 200) { this.$message.success('审核通过'); this.getReportData(); }
      else { this.$message.error((res && res.message) || '操作失败'); }
    },
    handleReject(row) {
      this.rejectRow = row; this.refundReason = ''; this.rejectShow = true;
    },
    async confirmReject() {
      if (!this.refundReason.trim()) { this.$message.warning('请输入驳回原因'); return; }
      const res = await adminApproveReport({
        id: this.rejectRow.id, approve_status: 3, refund_reason: this.refundReason,
      });
      if (res && res.code === 200) { this.$message.success('已驳回'); this.rejectShow = false; this.getReportData(); }
      else { this.$message.error((res && res.message) || '操作失败'); }
    },
    getStatusType(row) {
      if (row.is_save == 1) return 'warning';
      if (row.approve_status == 2) return 'success';
      if (row.approve_status == 3) return 'danger';
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
@import url("month_report.scss");
</style>
